<template>
  <div class="event-table">
    <el-table
      :data="invitationArray"
      style="width: 100%"
      empty-text="No invitations"
    >
      <el-table-column prop="name" label="Users" :width="300">
        <template #default="scope">
          <router-link
            :to="{
              name: 'UserProfile',
              params: { link: scope.row.link },
            }"
          >
            <div class="event-table__user">
              <el-avatar class="event-table__avatar" :size="50">
                <user-avatar :userId="scope.row.userId" :alt="scope.row.name" />
              </el-avatar>
              <span class="event-table__name">
                {{ scope.row.name }}

                <div class="event-table__expiration-date">
                  {{
                    formatDate(
                      scope.row.expirationDate,
                      DEFAULT_DATETIME_FORMAT,
                    )
                  }}
                </div>
              </span>
            </div>
          </router-link>
        </template>
      </el-table-column>
      <el-table-column prop="comments" label="Comment">
        <template #default="scope">
          <div class="dash-if-empty event-table__comment">
            {{ scope.row.comments }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="Status" :width="120">
        <template #default="scope">
          <div>
            {{ scope.row.status }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="" :width="200">
        <template #default="scope">
          <el-button
            type="primary"
            @click="requestCancelInvitation(scope.row)"
            v-if="scope.row.status === 'Active'"
            :disabled="isButtonDisabled('cancel-invitation')"
          >
            Cancel invitation
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {
  getOutgoingInvitations,
  cancelOutgoingInvitation,
} from '@/api/events.js';
import { DEFAULT_DATETIME_FORMAT, formatDate } from '@/utils/index.js';
import { showMessage } from '@/utils/messages.js';
import { disableButton } from '@/mixins/disableButton.js';
import UserAvatar from '@/components/profile/UserAvatar.vue';

export default {
  name: 'EventInvitations',
  props: {
    eventId: {
      type: Number,
      required: true,
    },
  },
  components: {
    UserAvatar,
  },
  mixins: [disableButton],
  data() {
    return {
      invitationArray: [],
      DEFAULT_DATETIME_FORMAT,
    };
  },
  methods: {
    formatDate,
    showMessage,
    async fetchInvitations() {
      const { eventId } = this;
      const { data, success } = await getOutgoingInvitations({ eventId });

      if (success) {
        this.setData(data.items);
      }
    },
    async requestCancelInvitation({ invitationId }) {
      this.disableButton('cancel-invitation');
      const { success } = await cancelOutgoingInvitation({ invitationId });
      this.enableButton('cancel-invitation');

      if (success) {
        this.showMessage({
          type: 'success',
          message: 'Invitation has been canceled',
        });
        this.fetchInvitations();
      }
    },
    setData(data) {
      this.invitationArray = data.map((invitation) => {
        return {
          invitationId: invitation.invitationId,
          name: invitation.user.firstName + ' ' + invitation.user.lastName,
          userId: invitation.user.userId,
          link: invitation.user.link,
          status: invitation.status,
          comments: invitation.comments,
          expirationDate: invitation.expirationDate,
        };
      });
    },
  },
  created() {
    this.fetchInvitations();
  },
};
</script>
